import { animate, style, transition, trigger } from '@angular/animations';
import { Component, computed, inject, Signal } from '@angular/core';
import { LoadingService } from '@core/services/loading.service';

import { IconComponent } from '../../../shared/components/icon/icon.component';

@Component({
    selector: 'app-loader',
    imports: [IconComponent],
    templateUrl: 'loader.component.html',
    styleUrl: 'loader.component.css',
    animations: [
        trigger('fade', [
            transition(':enter', [style({ opacity: 0 }), animate(200, style({ opacity: 1 }))]),
            transition(':leave', [style({ opacity: 1 }), animate(200, style({ opacity: 0 }))]),
        ]),
    ],
})
export class LoaderComponent {
    private loadingService: LoadingService = inject(LoadingService);

    public isLoading: Signal<boolean> = computed(() => this.loadingService.isLoading());
}
